const KEYS = {
  ACCESS: 'access_token',
  REFRESH: 'refresh_token',
  REMEMBER: 'remember_me',
} as const;

// Dwa tryby trwałości sesji:
//
// • rememberMe = false ("Nie wylogowywuj mnie" ODZNACZONE) — tokeny żyją WYŁĄCZNIE w pamięci JS.
//   Giną przy każdym przeładowaniu/zamknięciu strony, więc po odświeżeniu lub powrocie na czat
//   użytkownik jest wylogowany i ląduje na stronie głównej.
//
// • rememberMe = true ("Nie wylogowywuj mnie" ZAZNACZONE) — tokeny w localStorage. Sesja trwa do
//   180 dni: przeżywa odświeżenie, nawigację i restart przeglądarki. Backend wystawia wtedy
//   refresh-token o długim TTL.
let memAccess: string | null = null;
let memRefresh: string | null = null;

function rememberEnabled(): boolean {
  return localStorage.getItem(KEYS.REMEMBER) === '1';
}

export const authStorage = {
  // Pamięć ma pierwszeństwo (tryb sesyjny); w trybie zapamiętanym czytamy z localStorage.
  getAccessToken: () => memAccess || localStorage.getItem(KEYS.ACCESS),
  getRefreshToken: () => memRefresh || localStorage.getItem(KEYS.REFRESH),
  isRememberMeEnabled: rememberEnabled,

  setTokens: (accessToken: string, refreshToken: string, rememberMe?: boolean) => {
    // Gdy rememberMe nie podane (np. cichy refresh tokena) — zachowaj bieżący tryb.
    const persist = rememberMe === undefined ? rememberEnabled() : rememberMe;

    if (persist) {
      localStorage.setItem(KEYS.REMEMBER, '1');
      localStorage.setItem(KEYS.ACCESS, accessToken);
      localStorage.setItem(KEYS.REFRESH, refreshToken);
      memAccess = null;
      memRefresh = null;
    } else {
      localStorage.removeItem(KEYS.REMEMBER);
      localStorage.removeItem(KEYS.ACCESS);
      localStorage.removeItem(KEYS.REFRESH);
      memAccess = accessToken;
      memRefresh = refreshToken;
    }
    // Sprzątanie po starym schemacie (tokeny w sessionStorage).
    sessionStorage.removeItem(KEYS.ACCESS);
    sessionStorage.removeItem(KEYS.REFRESH);
  },

  // Przełączenie trybu w trakcie sesji — przenosi już posiadane tokeny do właściwego magazynu.
  setRememberMe: (enabled: boolean) => {
    if (enabled) {
      localStorage.setItem(KEYS.REMEMBER, '1');
      if (memAccess) localStorage.setItem(KEYS.ACCESS, memAccess);
      if (memRefresh) localStorage.setItem(KEYS.REFRESH, memRefresh);
      memAccess = null;
      memRefresh = null;
    } else {
      localStorage.removeItem(KEYS.REMEMBER);
      const a = localStorage.getItem(KEYS.ACCESS);
      const r = localStorage.getItem(KEYS.REFRESH);
      if (a) memAccess = a;
      if (r) memRefresh = r;
      localStorage.removeItem(KEYS.ACCESS);
      localStorage.removeItem(KEYS.REFRESH);
    }
  },

  clear: () => {
    memAccess = null;
    memRefresh = null;
    localStorage.removeItem(KEYS.REMEMBER);
    localStorage.removeItem(KEYS.ACCESS);
    localStorage.removeItem(KEYS.REFRESH);
    sessionStorage.removeItem(KEYS.ACCESS);
    sessionStorage.removeItem(KEYS.REFRESH);
  },
};
